import {authAxios} from "../utils";
import {notification, Modal} from "antd";
import {
  ExclamationCircleOutlined,
} from "@ant-design/icons";

export const changeState = (params = {}) => {
        return authAxios(localStorage.getItem('token'))
        .post(ticketChangeState,params)
    }

export function openNotificationWithIcon (type,message,description) {
  notification[type]({
    message: message,
    description: description
  });
};

export const confirm_modal = (content, functData, params) => {
    Modal.confirm({
      title: "Xác nhận",
      icon: <ExclamationCircleOutlined />,
      content: content,
      okText: "Đồng ý",
      cancelText: "Hủy",
      onOk: () => {
        functData(params);
      },
      // onCancel: () => {
      //   console.log('User clicked Cancel');
      //   // Thực hiện logic xử lý khi bấm Cancel tại đây
      // },
    });
  };
